// css =>
import "../../BaseStructure.css";
import Styled from "./headerTittle.module.css";

function HeaderTittle(props: { headerTittleList?: string[] }) {
    return(
        <div className={`row ${ Styled.HeaderTittleBox }`}>
            <div className="col-1">.</div>
            
            <div className="col-10">
                {
                    props.headerTittleList?.slice(0, -1).map((tittle, idx) => (
                        <div className="col-2" key={idx}>
                            <p>{ tittle }</p>
                        </div>
                    ))
                }
            </div>


            <div className="col-1">
                {
                    props.headerTittleList && props.headerTittleList.length > 0 && (
                        <div className="col-12">
                            <p>{ props.headerTittleList[props.headerTittleList.length - 1] }</p>
                        </div>
                    )
                }
                {/* {
                    props.headerTittleList ? (
                        <div className="col-2" key={ props.headerTittleList[props.headerTittleList.length - 1] }>
                            <p>{ props.headerTittleList[props.headerTittleList.length - 1] }</p>
                        </div>
                    ) : (
                        <p>jdsj</p>
                    )
                } */}
            </div>
        </div>
    );
}

export default HeaderTittle;
